import { computed, inject, isSignal } from '@angular/core';

import { AskHrChatFeatureId } from '@core/ask-hr-types';
import { injectPreviewAskEnabled } from '@core/intelligence-contracts';
import { HrAssistantConfigDataService } from '@core/intelligence-logic';
import { provideHrAssistantFeature } from '@core/intelligence-smart-ui';

import { ChatRequestFormFeatureComponent } from './chat-request-form-feature/chat-request-form-feature.component';
import { ChatTemplatesListFeatureComponent } from './chat-templates-list-feature/chat-templates-list-feature.component';
import { TemplatesWelcomeComponent } from './templates-welcome.component';

export const CHAT_FORMS_LIST_FEATURE = provideHrAssistantFeature({
  useValue: {
    id: AskHrChatFeatureId.Forms,
    welcomeCmp: TemplatesWelcomeComponent,
    welcomeCmpVisible: () => {
      const askHrPreview = injectPreviewAskEnabled({ optional: true });
      if (isSignal(askHrPreview)) {
        return askHrPreview;
      }
      const hrAssistantConfigDataService = inject(HrAssistantConfigDataService);
      hrAssistantConfigDataService.fetchIfNotLoaded();
      return computed(() => hrAssistantConfigDataService.configData()?.ask.enabled ?? false);
    },
    activateCmp: ChatTemplatesListFeatureComponent,
  },
});

export const CHAT_FORM_FEATURE = provideHrAssistantFeature({
  useValue: {
    id: AskHrChatFeatureId.Form,
    welcomeCmp: null,
    activateCmp: ChatRequestFormFeatureComponent,
  },
});
